import { render, staticRenderFns } from "./TemplateSearchNoData.vue?vue&type=template&id=fb48690c&scoped=true&"
import script from "./TemplateSearchNoData.vue?vue&type=script&lang=js&"
export * from "./TemplateSearchNoData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb48690c",
  null
  
)

export default component.exports